import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { StyledSocialShareButtonsComponent } from "./social-share-buttons-component.scss";
import FacebookShareLogo from "static/svg/social-share/share-facebook.svg";
import TwitterShareLogo from "static/svg/social-share/share-twitter.svg";
import LinkedinShareLogo from "static/svg/social-share/share-linkedin.svg";
import StoriesFacebookShareLogo from "static/svg/social-share/stories/stories-share-facebook.svg";
import StoriesTwitterShareLogo from "static/svg/social-share/stories/stories-share-twitter.svg";
import StoriesLinkedinShareLogo from "static/svg/social-share/stories/stories-share-linkedin.svg";
import { trackEvent } from "/services/bigbrain-service";
import { SOCIAL_SHARE } from "/constants/bigbrain-event-types";
import { FACEBOOK_SHARE_URL_PREFIX, TWITTER_SHARE_URL_PREFIX, LINKEDIN_SHARE_URL_PREFIX } from "/constants/social-share-urls";
class SocialShareButtonsComponent extends PureComponent {
    sharePage(urlPrefix, kind) {
        trackEvent(SOCIAL_SHARE, {
            kind
        });
        window.open(urlPrefix + document.URL);
    }
    shareFacebook() {
        this.sharePage(FACEBOOK_SHARE_URL_PREFIX, "facebook");
    }
    shareTwitter() {
        this.sharePage(TWITTER_SHARE_URL_PREFIX, "twitter");
    }
    shareLinkedin() {
        this.sharePage(LINKEDIN_SHARE_URL_PREFIX, "linkedin");
    }
    render() {
        const { direction, color, scrollMode, blogStyle, storiesLogos, className, style } = this.props;
        const directionValue = blogStyle ? "vertical" : direction;
        const colorValue = blogStyle ? "white" : color;
        const FacebookLogo = storiesLogos ? StoriesFacebookShareLogo : FacebookShareLogo;
        const TwitterLogo = storiesLogos ? StoriesTwitterShareLogo : TwitterShareLogo;
        const LinkedinLogo = storiesLogos ? StoriesLinkedinShareLogo : LinkedinShareLogo;
        return /*#__PURE__*/ _jsxs(StyledSocialShareButtonsComponent, {
            className: classnames("social-share-buttons-component", directionValue, colorValue, className, {
                "scroll-mode": scrollMode,
                "blog-style": blogStyle
            }),
            style: style,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "share-button-container facebook-share",
                    onClick: this.shareFacebook,
                    children: /*#__PURE__*/ _jsx(FacebookLogo, {})
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "share-button-container twitter-share",
                    onClick: this.shareTwitter,
                    children: /*#__PURE__*/ _jsx(TwitterLogo, {})
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "share-button-container linkedin-share",
                    onClick: this.shareLinkedin,
                    children: /*#__PURE__*/ _jsx(LinkedinLogo, {})
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.shareFacebook = this.shareFacebook.bind(this);
        this.shareTwitter = this.shareTwitter.bind(this);
        this.shareLinkedin = this.shareLinkedin.bind(this);
    }
}
export { SocialShareButtonsComponent as default };
SocialShareButtonsComponent.defaultProps = {
    direction: "horizontal",
    color: "black",
    stickyMode: false,
    blogStyle: false
};
